import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

// 📌 IMPORTAR COMPONENTES
import UserPanel from "./components/clientes/UserPanel"; // Panel de usuario
import RestauranteMenu from "./components/clientes/RestauranteMenu"; // Menú con popup de registro
import ModalRegistro from "./components/clientes/ModalRegistro"; // Modal de registro
import Cuenta from "./components/clientes/views/Cuenta"; // Vista completa de Cuenta
import Ofertas from "./components/clientes/views/Ofertas"; // Importar la vista de ofertas
import OnlineOrdering from "./components/clientes/online/OnlineOrdering";
import OnlineCart from "./components/clientes/online/OnlineCart";
import OnlineCheckout from "./components/clientes/online/OnlineCheckout";
import SalycomeHome from "./components/public/SalycomeHome";

import AdminPanel from "./components/AdminPanel";
import CustomerView from "./components/CustomerView";
import VinosList from "./components/VinosList";
import CloverAuth from "./components/SuperAdmin/CloverAuth";
import Categories from "./components/restaunt_admin/Category";
import Products from "./components/restaunt_admin/Products";
import Settings from "./components/restaunt_admin/Settings";
import SuperAdminDashboard from "./components/SuperAdmin/SuperAdminDashboard";
import EstablecerPassword from "./components/restaunt_admin/EstablecerPassword";
import Login from "./components/restaunt_admin/Login";
import SuperAdminLogin from "./components/SuperAdmin/SuperAdminLogin";
import RestauranteDashboard from "./components/restaunt_admin/RestauranteDashboard";
import PrivateRoute from "./components/shared/PrivateRoute";
import SuperAdminMenu from "./components/SuperAdmin/SuperAdminMenu";
import Popup from "./components/restaunt_admin/Popup";
import CrearOferta from "./components/restaunt_admin/CrearOferta";

import "./App.css";

function App() {
  const [language, setLanguage] = useState("es"); // Idioma predeterminado: español

  // Maneja el cambio de idioma
  const handleLanguageChange = async (code) => {
    setLanguage(code);
    console.log(`Idioma cambiado a: ${code}`);
  };

  const isAuthenticated = () => !!localStorage.getItem("token");

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <main>
            <Routes>
              {/* ✅ Rutas Públicas */}
              <Route path="/" element={<h2>Bienvenido a la Cava de Vinos</h2>} />
              <Route path="/login" element={<Login />} />
              <Route path="/super-admin/login" element={<SuperAdminLogin />} />
              <Route path="/establecer-password" element={<EstablecerPassword />} />

              <Route path="/salycome" element={<SalycomeHome />} />

              {/* ✅ RUTA PARA MOSTRAR EL MENÚ DIGITAL */}
              <Route path="/menu/:cliente_id" element={<RestauranteMenu />} />

              {/* ✅ REGISTRO - Muestra el popup o la vista completa */}
              <Route path="/registro" element={<ModalRegistro />} />
              <Route path="/usuario/cuenta" element={<Cuenta />} />

              {/* ✅ PANEL DE USUARIO - Una vez registrado puede navegar aquí */}

               <Route path="/usuario/:usuario_id" element={<UserPanel />} />
               <Route path="/usuario/:usuario_id/ofertas" element={<Ofertas />} />

              {/* ✅ ACCESO DIRECTO AL MENÚ DIGITAL SIN REGISTRO */}
              <Route path="/clientes/menu/:cliente_id" element={<RestauranteMenu />} />

              <Route path="/ordenar-en-linea/:cliente_id" element={<OnlineOrdering />} />
              <Route path="/carrito/:cliente_id" element={<OnlineCart />} />
               <Route path="/checkout/:cliente_id" element={<OnlineCheckout />} />







  <Route
    path="/super-admin"
    element={
      <PrivateRoute
        component={SuperAdminMenu} // Componente del menú principal
        allowedRoles={["super_admin"]}
      />
    }
  />

  {/* Dashboard Principal */}
  <Route
    path="/super-admin/dashboard"
    element={
      <PrivateRoute
        component={SuperAdminDashboard} // Dashboard principal
        allowedRoles={["super_admin"]}
      />
    }
  />

  {/* Configuración Clover */}
  <Route
    path="/super-admin/clover-auth"
    element={
      <PrivateRoute
        component={CloverAuth} // Configuración de Clover
        allowedRoles={["super_admin"]}
      />
    }
  />
              <Route
                path="/super-admin/dashboard/:cliente_id"
                element={
                  <PrivateRoute
                    component={RestauranteDashboard}
                    allowedRoles={["super_admin"]}
                  />
                }
              />

              {/* Rutas protegidas para Clientes */}
              <Route
                path="/dashboard/:cliente_id"
                element={
                  <PrivateRoute
                    component={RestauranteDashboard}
                    allowedRoles={["cliente", "super_admin"]}
                  />
                }
              />
              <Route
                path="/clover-categories"
                element={
                  <PrivateRoute component={Categories} allowedRoles={["cliente"]} />
                }
              />
              <Route
                path="/clover-products"
                element={
                  <PrivateRoute component={Products} allowedRoles={["cliente"]} />
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute component={Settings} allowedRoles={["cliente"]} />
                }
              />
               {/* Nueva Ruta para Gestión de Popups */}
              <Route
                path="/popups/"
                element={
                 <PrivateRoute component={Popup} allowedRoles={["cliente"]} />       
                }
              />

              <Route
                path="/crear-oferta"
                element={
                  <PrivateRoute component={CrearOferta} allowedRoles={["cliente"]} />
                 }
               />


              {/* Rutas compartidas entre Super Admin y Cliente */}
              <Route
                path="/list"
                element={
                  <PrivateRoute
                    component={VinosList}
                    allowedRoles={["super_admin", "cliente"]}
                  />
                }
              />
`
              {/* Rutas protegidas de Admin Panel */}
              <Route
                path="/admin"
                element={
                  <PrivateRoute component={AdminPanel} allowedRoles={["super_admin"]} />
                }
              />
              <Route
                path="/customer"
                element={
                  <PrivateRoute component={CustomerView} allowedRoles={["cliente"]} />
                }
              />

              {/* Ruta por defecto */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
